// aboutus.jsx
import React from 'react';
import './aboutus.css';
import Sidebar from '../sidebar/sidebar';

const AboutUs = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src="https://sssdemo-images.s3.ap-south-1.amazonaws.com/images/2.png" // Replace with your image URL
          alt="About Us"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default AboutUs;
